import React from "react";

const logos = [
  "/partners/iith1.png",
  "/partners/prasanth1.png",
  "/partners/wind3.png",
  "/partners/ls2.png",
  "/partners/lab1.png",
  "/partners/tic.png",
];

function ClientPartners() {

  const infiniteLogos = [...logos, ...logos];

  return (
    <section className="relative overflow-hidden py-24">

      {/* ================= PREMIUM TOP ARCH ================= */}
        {/* ================= CURVED TOP ARCH ================= */}
        <div className="absolute top-0 left-0 w-full overflow-hidden leading-none z-10">

        <svg
            className="relative block w-full h-[120px]"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            viewBox="0 0 1440 320"
        >
            <path
            
            d="M0,96L120,122.7C240,149,480,203,720,208C960,213,1200,171,1320,149.3L1440,128L1440,0L0,0Z"
            />
        </svg>

        </div>

   

      {/* ================= BACKGROUND ================= */}
      <div className="absolute inset-0 bg-gradient-to-br from-black via-[#0b0f19] to-[#111827] opacity-95"></div>

      {/* ================= GLOW EFFECTS ================= */}
      <div className="absolute inset-0 opacity-35 pointer-events-none">

        <div
          className="absolute top-0 left-0 w-[120%] h-[120%]
          bg-gradient-to-r from-orange-500/30 via-yellow-400/20 to-sky-500/30
          blur-3xl animate-slowWave"
        ></div>

        <div
          className="absolute bottom-0 right-0 w-[120%] h-[120%]
          bg-gradient-to-r from-sky-500/20 via-orange-300/20 to-yellow-400/30
          blur-3xl animate-fastWave"
        ></div>

      </div>

      {/* ================= GRID ================= */}
      <div
        className="
          absolute inset-0 opacity-[0.05]
          bg-[linear-gradient(to_right,white_1px,transparent_1px),
          linear-gradient(to_bottom,white_1px,transparent_1px)]
          bg-[size:60px_60px]
        "
      />

      {/* ================= FLOATING PARTICLES ================= */}
      <div className="absolute inset-0 overflow-hidden">

        {[...Array(20)].map((_, i) => (
          <span
            key={i}
            className="particle"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 10}s`,
              animationDuration: `${12 + Math.random() * 10}s`,
              width: `${4 + Math.random() * 6}px`,
              height: `${4 + Math.random() * 6}px`,
            }}
          />
        ))}

      </div>

      {/* ================= MAIN ================= */}
      <div className="relative z-10">

        {/* ================= HEADING ================= */}
        <div className="text-center mb-16 px-6">

          <p className="uppercase tracking-[5px] text-orange-300 text-[11px] font-medium">
            Our Clients & Partners
          </p>

          <h2 className="mt-4 text-3xl md:text-5xl font-black leading-tight tracking-tight text-white">
            Trusted Across
            <span className="bg-gradient-to-r from-orange-300 via-yellow-200 to-cyan-300 bg-clip-text text-transparent">
              {" "}Industries
            </span>
          </h2>

          <p className="mt-5 max-w-3xl mx-auto text-slate-400 text-sm md:text-base leading-relaxed">
            Power Sense collaborates with leading institutions,
            industries, smart infrastructure companies and technology partners
            to build intelligent energy ecosystems.
          </p>

          {/* Badge */}
          <div className="mt-8 inline-flex items-center gap-3 px-6 py-3 rounded-full border border-white/10 bg-white/[0.04] backdrop-blur-xl">

            <span className="h-2 w-2 rounded-full bg-emerald-400 animate-pulse" />

            <p className="text-[13px] text-slate-400 tracking-wide">
              Serving Smart Campuses • Industries • Energy Labs
            </p>

          </div>

        </div>

        {/* ================= STATS ================= */}
        <div className="flex flex-wrap justify-center gap-6 mb-20 px-6">

          {[
            { number: "10+", label: "Deployments" },
            { number: "99.9%", label: "Monitoring Accuracy" },
            { number: "24/7", label: "IoT Analytics" },
          ].map((item, index) => (
            <div
              key={index}
              className="
                relative overflow-hidden
                px-8 py-5
                rounded-2xl
                border border-white/10
                bg-white/[0.03]
                backdrop-blur-lg
                shadow-lg
                hover:border-orange-400/20
                hover:bg-white/[0.05]
                transition-all duration-500
              "
            >

              {/* Top Border */}
              <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-orange-400/40 to-transparent" />

              <h3 className="text-2xl font-bold text-white">
                {item.number}
              </h3>

              <p className="mt-2 text-slate-500 text-[13px]">
                {item.label}
              </p>

            </div>
          ))}
        </div>

        {/* ================= FIRST ROW ================= */}
        <div className="relative overflow-hidden mb-10">

          {/* Left Fade */}
          <div className="absolute left-0 top-0 w-48 h-full bg-gradient-to-r from-black via-[#0b0f19] to-transparent z-20 pointer-events-none" />

          {/* Right Fade */}
          <div className="absolute right-0 top-0 w-48 h-full bg-gradient-to-l from-[#111827] via-[#0b0f19] to-transparent z-20 pointer-events-none" />

          {/* Track */}
          <div className="group flex w-max items-center animate-marquee">

            {infiniteLogos.map((logo, index) => (
              <div
                key={index}
                className="
                  relative overflow-hidden
                  mx-5
                  flex items-center justify-center
                  min-w-[160px] md:min-w-[220px]
                  h-[90px] md:h-[120px]
                  rounded-3xl
                  border border-white/10
                  bg-white/[0.04]
                  backdrop-blur-xl
                  shadow-[0_8px_40px_rgba(0,0,0,0.35)]
                  hover:bg-white/[0.06]
                  hover:border-orange-400/20
                  transition-all duration-500
                  hover:-translate-y-2
                  animate-float
                "
              >

                {/* Top Glow */}
                <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-orange-400/30 to-transparent" />

                <img
                  src={logo}
                  alt="partner"
                  className="
                    max-h-[75px] md:max-h-[85px]
                    max-w-[150px] md:max-w-[180px]
                    object-contain
                    brightness-125
                    contrast-125
                    saturate-125
                    grayscale
                    hover:grayscale-0
                    hover:scale-105
                    transition-all duration-500
                  "
                />

              </div>
            ))}

          </div>
        </div>

        {/* ================= SECOND ROW ================= */}
        <div className="relative overflow-hidden">

          {/* Left Fade */}
          <div className="absolute left-0 top-0 w-48 h-full bg-gradient-to-r from-black via-[#0b0f19] to-transparent z-20 pointer-events-none" />

          {/* Right Fade */}
          <div className="absolute right-0 top-0 w-48 h-full bg-gradient-to-l from-[#111827] via-[#0b0f19] to-transparent z-20 pointer-events-none" />

          {/* Reverse Track */}
          <div className="group flex w-max items-center animate-marquee-reverse">

            {[...infiniteLogos].reverse().map((logo, index) => (
              <div
                key={index}
                className="
                  relative overflow-hidden
                  mx-5
                  flex items-center justify-center
                  min-w-[160px] md:min-w-[220px]
                  h-[90px] md:h-[120px]
                  rounded-3xl
                  border border-white/10
                  bg-white/[0.04]
                  backdrop-blur-xl
                  shadow-[0_8px_40px_rgba(0,0,0,0.35)]
                  hover:bg-white/[0.06]
                  hover:border-sky-400/20
                  transition-all duration-500
                  hover:-translate-y-2
                  animate-float
                "
              >

                {/* Top Glow */}
                <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-sky-400/30 to-transparent" />

                <img
                  src={logo}
                  alt="partner"
                  className="
                    max-h-[75px] md:max-h-[85px]
                    max-w-[150px] md:max-w-[180px]
                    object-contain
                    brightness-125
                    contrast-125
                    saturate-125
                    grayscale
                    hover:grayscale-0
                    hover:scale-105
                    transition-all duration-500
                  "
                />

              </div>
            ))}

          </div>
        </div>

        {/* ================= FOOTER ================= */}
        <div className="mt-20 text-center px-6">

          <p className="text-slate-500 text-sm tracking-wide">
            Building the future of intelligent energy systems together.
          </p>

        </div>

      </div>

      {/* ================= ANIMATIONS ================= */}
      <style>
        {`

          @keyframes marquee {
            0% {
              transform: translate3d(0, 0, 0);
            }

            100% {
              transform: translate3d(-50%, 0, 0);
            }
          }

          @keyframes marqueeReverse {
            0% {
              transform: translate3d(-50%, 0, 0);
            }

            100% {
              transform: translate3d(0, 0, 0);
            }
          }

          @keyframes float {
            0%,100% {
              transform: translateY(0px);
            }

            50% {
              transform: translateY(-8px);
            }
          }

          @keyframes particleFloat {

            0% {
              transform: translateY(100vh) scale(0);
              opacity: 0;
            }

            10% {
              opacity: 0.4;
            }

            50% {
              opacity: 0.8;
            }

            100% {
              transform: translateY(-120vh) scale(1);
              opacity: 0;
            }
          }

          @keyframes slowWave {
            0% {
              transform: translate(-10%, -10%) rotate(0deg);
            }

            50% {
              transform: translate(10%, 10%) rotate(14deg);
            }

            100% {
              transform: translate(-10%, -10%) rotate(0deg);
            }
          }

          @keyframes fastWave {
            0% {
              transform: translate(10%, 10%) rotate(0deg);
            }

            50% {
              transform: translate(-10%, -10%) rotate(-14deg);
            }

            100% {
              transform: translate(10%, 10%) rotate(0deg);
            }
          }

          .animate-marquee {
            animation: marquee 28s linear infinite;
            will-change: transform;
          }

          .animate-marquee-reverse {
            animation: marqueeReverse 28s linear infinite;
            will-change: transform;
          }

          .animate-marquee:hover,
          .animate-marquee-reverse:hover {
            animation-play-state: paused;
          }

          .animate-float {
            animation: float 5s ease-in-out infinite;
          }

          .animate-slowWave {
            animation: slowWave 14s ease-in-out infinite;
          }

          .animate-fastWave {
            animation: fastWave 10s ease-in-out infinite;
          }

          .particle {
            position: absolute;
            bottom: -20px;
            border-radius: 999px;

            background:
              radial-gradient(circle,
              rgba(255,255,255,0.9) 0%,
              rgba(249,115,22,0.6) 40%,
              transparent 80%);

            filter: blur(1px);

            animation-name: particleFloat;
            animation-timing-function: linear;
            animation-iteration-count: infinite;
          }

        `}
      </style>

    </section>
  );
}

export default ClientPartners;